var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M10.8555 4H4.85547V10H10.8555V4ZM20.8555 4H14.8555V10H20.8555V4ZM4.85547 14H10.8555V20H4.85547V14ZM20.8555 14H14.8555V20H20.8555V14Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
